import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "@/lib/categories";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#E2E8F0] bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1 space-y-3">
          <h4 className="font-serif text-2xl font-semibold text-[#1A1A1A]">buscocompartir</h4>
          <p className="text-sm text-[#475569] leading-relaxed max-w-sm">
            Tu solución segura para compartir. Espacio para las personas que buscan un lugar seguro
            donde compartir recursos y necesidades.
          </p>
        </div>
        <div className="md:col-span-2 space-y-2">
          <p className="eyebrow">Categorías</p>
          <ul className="grid grid-cols-2 gap-y-1.5 text-sm text-[#1A1A1A]">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/anuncios?categoria=${c.slug}`} className="link-underline">
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-2">
          <p className="eyebrow">Plataforma</p>
          <ul className="space-y-1.5 text-sm text-[#1A1A1A]">
            <li><Link to="/" className="link-underline">Portada</Link></li>
            <li><Link to="/anuncios" className="link-underline">Todos los anuncios</Link></li>
            <li><Link to="/publicar" className="link-underline">Publicar anuncio</Link></li>
            <li><Link to="/mis-anuncios" className="link-underline">Mis anuncios</Link></li>
            <li><Link to="/premium" className="link-underline">Premium</Link></li>
            <li><Link to="/anunciantes" className="link-underline">Anunciantes</Link></li>
            <li><Link to="/aviso-legal" className="link-underline text-[#1E3A8A] font-semibold">Aviso legal</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs font-mono uppercase tracking-[0.16em] text-[#64748B]">
            © {new Date().getFullYear()} buscocompartir · Tu solución segura para compartir
          </p>
          <p className="text-xs text-[#64748B]">Elegante, seguro y directo.</p>
        </div>
      </div>
    </footer>
  );
}
